export default {
  dashboard: "Dashboard",
  totalTime: "Total Time",
  billableTime: "Billable Time",
  workingDays: "Working Days",
  avgDailyTime: "Avg. Daily Time",
  durationOverTime: "Duration Over Time",
  distribution: "Breakdown #1",
  breakdown: "Breakdown #2",
  sliceBy: "Group by",
  groupBy: "Group by",
  projects: "Projects",
  clients: "Clients",
  members: "Members",
  services: "Services",
  noData: "No data for the selected period",
  entityName: "Name",
  duration: "Duration",
  percentage: "Duration %",
  total: "Total",
  unassigned: "Unassigned",
  noClient: "No Client",
  project: "Project",
  client: "Client",
  member: "Member",
  service: "Service",
  date: "Date",
  durationByDay: "Duration by day",
  durationByWeek: "Duration by week",
  durationByMonth: "Duration by month",
  projectDistribution: "Project distribution",
  clientDistribution: "Client distribution",
  memberDistribution: "Member distribution",
  serviceDistribution: "Service distribution",
};
